// Tampilan nama layanan tanpa underscore ("SERVICE_BESAR" → "SERVICE BESAR"). Nilai asli tidak diubah.
export const svcLabel = (s) => String(s ?? "").replace(/_/g, " ");
